import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoCatalogoAlineacionDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoCatalogoAlineacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  getProyectoCatalogoAlineacionService(): Observable<
    BodyListResponse<ProyectoCatalogoAlineacionDTO>
  > {
    return this.http.get<BodyListResponse<ProyectoCatalogoAlineacionDTO>>(
      API_URL + '/api/v1/proyectoCatalogoAlineacion/todos',
    );
  }

  guardarProyectoCatalogoAlineacionService(
    proyectoCatalogoAlineacionDTO: ProyectoCatalogoAlineacionDTO,
  ): Observable<BodyResponse<ProyectoCatalogoAlineacionDTO>> {
    return this.http.post<BodyResponse<ProyectoCatalogoAlineacionDTO>>(
      API_URL + '/api/v1/proyectoCatalogoAlineacion',
      proyectoCatalogoAlineacionDTO,
    );
  }

  getProyectoCatalogoAlineacionPorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<ProyectoCatalogoAlineacionDTO>> {
    return this.http.get<BodyResponse<ProyectoCatalogoAlineacionDTO>>(
      API_URL + '/api/v1/proyectoCatalogoAlineacion/' + codigo,
    );
  }
}
